import { gql } from '@edreamsodigeo/frontend-api-client';

export const api = gql`
  fragment TechnicalStop on TechnicalStop {
    location {
      id
      iata
      cityIata
      cityName
      name
      countryName
      locationType
    }
    arrivalDate
    departureDate
  }
`;
